import {imagenQrRecibo} from './qrRecibo';
const dinero = value => Number.isSafeInteger(value) && value >= 0 ? `Bs ${(value / 100).toFixed(2)}` : 'No registrado';
export function lineasReciboReserva(entrega) {
  const r = entrega.recibo;
  if (!r) return [];
  return [[r.estado==='anulado'?'Consumo anulado':r.estado==='canjeado'?'Consumo canjeado':'Consumo disponible', dinero(r.consumoCentavos)]];
}
export const estadoReciboConsumo=r=>r.estado==='anulado'?'Anulado':r.estado==='canjeado'?'Canjeado':r.qr?'Disponible':'QR no disponible';
export const tieneReciboConsumo = entrega => Number.isSafeInteger(entrega?.recibo?.consumoCentavos) && entrega.recibo.consumoCentavos > 0;
export function datosReciboReserva(entrega){
 const r=entrega.recibo||{};
 const piso={'1P':'Planta baja','2P':'2do piso'}[r.piso]||r.piso||'';
 return [['Evento',r.eventoNombre||entrega.evento?.nombre||'No registrado'],['Fecha del evento',fechaEventoRecibo(r.fechaEvento||entrega.evento?.fechaInicio)],['Cliente',r.cliente||entrega.comprador||'No registrado'],['Zona',[r.zona||entrega.zonaTitulo,piso].filter(Boolean).join(' · ')||'No registrada'],['Promotor',r.promotor||'No registrado']];
}
export function fechaEventoRecibo(value){
 if(!value)return 'No registrada';
 const raw=String(value),date=new Date(/^\d{4}-\d\d-\d\dT\d\d:\d\d(?::\d\d)?$/.test(raw)?raw+'-04:00':raw);
 return Number.isNaN(date.getTime())?raw:date.toLocaleString('es-BO',{timeZone:'America/La_Paz',dateStyle:'medium',timeStyle:'short'});
}
export function detalleConsumoRecibo(entrega) {
  return (entrega.recibo?.paqueteIncluye || []).filter(v => typeof v === 'string')
    .flatMap(v => v.split(/\r?\n|\s*\+\s*|,/)).map(v => v.trim()).filter(Boolean)
    .filter(v => !/\b(?:entradas?|tickets?)\b/i.test(v) && !/^(?:\d+\s*)?(?:mesa|lounge|palco)(?:\s+\d+)?$/i.test(v));
}

export const fechaReciboReserva = millis => millis ? new Date(millis).toLocaleString('es-BO', { timeZone: 'America/La_Paz' }) : '';
export async function descargarReciboReserva(entrega) {
  if (!tieneReciboConsumo(entrega)) throw new Error('Esta reserva no tiene consumo disponible.');
  const { jsPDF } = await import('jspdf');
  const pdf = new jsPDF(); let y = 20;
  function texto(value, bold = false) {
    pdf.setFont('helvetica', bold ? 'bold' : 'normal');
    const lines = pdf.splitTextToSize(String(value), 175);
    for (const line of lines) {
      if (y > 278) { pdf.addPage(); y = 20; }
      pdf.text(line, 18, y); y += 6;
    }
  }
  pdf.setFontSize(15); texto('Recibo de consumo', true); pdf.setFontSize(10); y += 3;
  for(const [label,value] of datosReciboReserva(entrega))texto(`${label}: ${value}`);
  if (detalleConsumoRecibo(entrega).length) {
    y += 4; texto('Detalle de consumo', true);
    for (const detail of detalleConsumoRecibo(entrega)) texto(`- ${detail}`);
  }
  if(entrega.recibo.qr){
    if(y>210){pdf.addPage();y=20;}
    pdf.addImage(imagenQrRecibo(entrega.recibo.qr),'PNG',79,y+4,52,52);y+=64;
  }
  texto(estadoReciboConsumo(entrega.recibo),true);
  for (const [label, value] of lineasReciboReserva(entrega)) texto(`${label}: ${value}`, true);
  pdf.save(`recibo-consumo-${entrega.recibo.reservaId}.pdf`);
}
